package one.healthium.insights.ui.insights

import loco.INSIGHTS_FAVORITES_EMPTY_MESSAGE
import loco.INSIGHTS_FAVORITES_EMPTY_TITLE
import loco.INSIGHTS_RECENTS_EMPTY_MESSAGE
import loco.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES
import loco.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS
import loco.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS
import loco.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES
import loco.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS
import one.healthium.domain.user.UserModel
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.ui.insights.models.EmptyUiModel
import one.healthium.insights.ui.insights.models.HeaderUiModel
import one.healthium.insights.ui.insights.models.SpaceUiModel
import one.healthium.loco.LString
import one.healthium.loco.asLString
import androidx.compose.runtime.Immutable

@Immutable
internal data class InsightsUiState(
    val loading: Boolean = false,
    val user: UserModel? = null,
    val isMetrics: Boolean = false,
    val insightsScreen: ContentScreenModel? = null,
    internal val favorites: List<SavedContentModel>? = null,
    internal val recently: List<SavedContentModel>? = null,
) {
    val favoritesUiData: List<Any>? = favorites
        ?.let(::buildSavedContentList)
        ?.ifEmpty {
            listOf(
                EmptyUiModel(
                    title = loco.Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE.asLString(),
                    message = loco.Res.string.INSIGHTS_FAVORITES_EMPTY_MESSAGE.asLString(),
                )
            )
        }
    val recentlyUiData: List<Any>? = recently
        ?.let(::buildSavedContentList)
        ?.ifEmpty {
            listOf(
                EmptyUiModel(
                    title = loco.Res.string.INSIGHTS_FAVORITES_EMPTY_TITLE.asLString(),
                    message = loco.Res.string.INSIGHTS_RECENTS_EMPTY_MESSAGE.asLString(),
                )
            )
        }

    private fun buildSavedContentList(favoritesList: List<SavedContentModel>): List<Any> = buildList {
        val savedContentToContentType = favoritesList.groupBy { it.contentOptions.toContentType() }
        ContentType.entries.sortedBy { it.order }.forEach { contentType ->
            savedContentToContentType[contentType]?.let { favoritesOfType ->
                if (favoritesOfType.isNotEmpty()) {
                    add(HeaderUiModel(contentType.name, contentType.displayName()))
                    addAll(favoritesOfType)
                }
            }
        }
        if (isNotEmpty()) add(SpaceUiModel(160))
    }
}

private enum class ContentType(val order: Int) {
    Recipe(0),
    Insight(1),
    MealPlan(2),
    Workout(3),
    Category(4),
}

private fun ContentOptions.toContentType() = when (this) {
    is ContentOptions.Category -> ContentType.Category
    is ContentOptions.Insight -> ContentType.Insight
    is ContentOptions.Recipe -> ContentType.Recipe
    is ContentOptions.MealPlan -> ContentType.MealPlan
    is ContentOptions.Workout -> ContentType.Workout
}

private fun ContentType.displayName(): LString = when (this) {
    ContentType.Recipe -> loco.Res.string.INSIGHTS_SAVED_CONTENT_HEADER_RECIPES.asLString()
    ContentType.Insight -> loco.Res.string.INSIGHTS_SAVED_CONTENT_HEADER_INSIGHTS.asLString()
    ContentType.MealPlan -> loco.Res.string.INSIGHTS_SAVED_CONTENT_HEADER_MEAL_PLANS.asLString()
    ContentType.Workout -> loco.Res.string.INSIGHTS_SAVED_CONTENT_HEADER_WORKOUTS.asLString()
    ContentType.Category -> loco.Res.string.INSIGHTS_SAVED_CONTENT_HEADER_CATEGORIES.asLString()
}
